import { ref, onMounted, watch } from "@vue/composition-api";
import { symbol, symbolTriangle } from "d3";
import { DefaultConfigs, IPadProConfigs } from "../services/DefaultConfigs";
import { getTextHeight } from "../services/Canvas2DContext";

export default function useYAxisArrow(configRef, marginRef, availableWidthRef, availableHeightRef, xRef, yRef, isIPadProRef) {
  const arrow = ref(null);

  const updateArrow = () => {
    if (!configRef?.value?.yAxis?.arrow || !marginRef?.value || !availableWidthRef?.value || !availableHeightRef?.value || !xRef?.value || !yRef?.value) {
      arrow.value = null;
      return;
    }

    const { up, down, color } = configRef.value.yAxis.arrow;

    if (!up && !down) {
      arrow.value = null;
      return;
    }

    const upFont = `${up?.fontSize ?? isIPadProRef?.value ? IPadProConfigs.YAxis.arrow.fontSize : DefaultConfigs.YAxis.arrow.fontSize} ${up?.fontFamily ?? DefaultConfigs.YAxis.arrow.fontFamily}`;
    const downFont = `${down?.fontSize ?? isIPadProRef?.value ? IPadProConfigs.YAxis.arrow.fontSize : DefaultConfigs.YAxis.arrow.fontSize} ${down?.fontFamily ?? DefaultConfigs.YAxis.arrow.fontFamily}`;

    const edgeSymbol = symbol()
      .type(symbolTriangle)
      .size(DefaultConfigs.YAxis.arrow.edgeSize)();

    const upTextHeight = getTextHeight(upFont);
    const downTextHeight = getTextHeight(downFont);

    arrow.value = {
      x: marginRef.value.left + availableWidthRef.value,
      color,
      dot: up && down && {
        y: yRef.value((up ?? down).y1),
        radius: DefaultConfigs.YAxis.arrow.dotRadius,
      },
      up: up && {
        y1: yRef.value(up.y1),
        y2: yRef.value(up.y2),
        label: {
          font: upFont,
          text: up.label,
          y: -upTextHeight - (up.labelShift ?? DefaultConfigs.YAxis.arrow.labelShift),
          x: yRef.value(up.y1) - ((yRef.value(up.y1) - yRef.value(up.y2)) / 2),
        },
        edgeY: yRef.value(up.y2) + DefaultConfigs.YAxis.arrow.edgeShift,
        edgeSymbol,
      },
      down: down && {
        y1: yRef.value(down.y1),
        y2: yRef.value(down.y2),
        label: {
          font: downFont,
          text: down.label,
          y: -downTextHeight - (down.labelShift ?? DefaultConfigs.YAxis.arrow.labelShift),
          x: yRef.value(down.y1) - ((yRef.value(down.y1) - yRef.value(down.y2)) / 2),
        },
        edgeY: yRef.value(down.y2) - DefaultConfigs.YAxis.arrow.edgeShift,
        edgeSymbol,
      },
    };
  };

  watch([marginRef, configRef, availableWidthRef, availableHeightRef, xRef, yRef, isIPadProRef], updateArrow);

  onMounted(updateArrow);

  return { arrow };
}
